<template>
  <div class="books-preview">
    <div
      v-for="item in $$FormData.flowers"
      :key="item.id"
      class="house-item"
    >
      <img :src="getCoverImage(item)" class="house-image" alt/>
      <span class="house-name ellipsis-2">{{ item.name }}</span>
      <div class="house-location">
        <div class="location-box">
          <div class="icon-location"/>
          <span class="house-address">{{ item.addr }}</span>
        </div>
        <div class="gg-btn solid">了解书房</div>
      </div>
    </div>
    <div v-if="!$$FormData.flowers.length" class="empty">
      请选择花城书房
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookFlowerHousePreview',
  methods: {
    getCoverImage(item) {
      const pic_url = item.pic_url || ''
      return pic_url.split(',')[0]
    }
  }
}
</script>

<style scoped lang="scss">
.books-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.house-item {
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  overflow: hidden;
  padding: 14px 11px;
  border-radius: 10px;
  background-color: #ffffff;
  box-sizing: border-box;
  .house-image {
    width: 100%;
    height: 160px;
    border-radius: 10px;
  }
  .house-name {
    margin-top: 10px;
    color: #3C4353;
    font-size: 16px;
    font-weight: bold;
    line-height: 23px;
    letter-spacing: 0;
  }
  .house-location {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 10px;
    .location-box {
      display: flex;
    }
    .icon-location {
      position: relative;
      top: 2px;
      width: 10px;
      height: 12px;
      margin-right: 5px;
      flex-shrink: 0;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFwAAAAD1fYotAAACT0lEQVQ4EZ1US24aQRCtGhAWIguOMLkBRzA7O14YFnGCiWQ4QfAJsE8QcgKwFOKEjZVFgnd2TmBu4LmBiRKCQGI67zU0mhnADi6J6fq8elNdVYzKBun2+jUVPUS4YETyhKnIEPqteno7+f33W71eHibTgYnLgqgJrx+PxC0QD00Ynr97+6oVjSwJ2+2r/M6LbFOMNKKAp3QQd6aj8amrNu0SMrnsB5DVnP2/JyqqIZfwOh8eH5++/GgwQP05wtzu1/4Zc5VXxRvu4bSNTxLC3wnF/FTPMzIzBaOCYa3FBjozxTTITh4DVCr7QeQlF5eX/Y8mpTfw+RE/VT9MyW5aVUro3YqgnPJx5SAAgR96aIfqA5p/wRfAVwTpfTJJVU88kPnJgKjcVo8OBmwHqwGwiVu0dnLZO2Jt1cCs5IGLQ/GTAWMkoC+Ty/g4+HPid3vfCzQcxgUWpyUMEk7cbk7CKhGLxoPpaGpth0nkBh6uF02Yx43ssnc0ODm0pcUfdS4wY6jQVjpPWDzBpd3e9Xv2JxaYG3YNElMWS5bSK0BWCDHbhhIQpvQOpPkkKQBDNdKRlA5kNvul6h2GIqVNWGzBS8REuOWcZJJwG9sYc159s39mCZn4uXfNa5S2IVlisULHr/eKtO1/mcpkNK7jGFDfUgaTP+Oyy1lWSIf9hOWyN1BXGu4SEucAhdjJO3+M0Dkx+TYCNWevOzGwTvVoj7eKyVpCIh4j3UTGvGUPaUTFvl3X7Cd86ypzuRsJCcDkTrkODkydPmc/++Seui/yUyT/ADDv5zh80HthAAAAAElFTkSuQmCC");
    }
    .house-address {
      opacity: 1;
      color: #A6AAB8;
      font-size: 12px;
      line-height: 17px;
    }
    .gg-btn {
      width: 70px;
      height: 18px;
      font-size: 12px;
      flex-shrink: 0;
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  width: 100%;
  height: 75px;
}
</style>